<template>
  <div>
    <BaseGreyText class="mb-1">
      {{ $t('Member since') }}
      {{ attributes.conventionSignedAt | moment('DD/MM/YYYY') }}
    </BaseGreyText>
    <div class="mb-8">
      <BaseOrangeText>
        {{ attributes.totalInvested | currency }} {{ $t('invested') }}
      </BaseOrangeText>
    </div>
    <BaseSectionHeader class="pt-4 border-t border-strong-shadow-color">
      {{ $t('Documents') }}
    </BaseSectionHeader>
    <BaseMenuList
      :items="documents"
      class="mb-6"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BaseGreyText from '../../components/BaseGreyText.vue';
import BaseOrangeText from '../../components/BaseOrangeText.vue';
import BaseMenuList from '../../components/BaseMenuList.vue';
import BaseSectionHeader from '../../components/BaseSectionHeader.vue';
import { OPENED_CONVENTION, OPENED_LETTER_OF_MISSION } from '../../analytics';

export default {
  name: 'ProfileSummary',
  components: {
    BaseGreyText,
    BaseOrangeText,
    BaseMenuList,
    BaseSectionHeader,
  },
  props: {
    attributes: {
      type: Object,
      required: true,
    },
  },
  computed: {
    documents() {
      const $this = this;
      const documents = [{
        title: "Convention d'adhésion au club Kerala",
        onClick() {
          analytics.track(OPENED_CONVENTION);
          $this.openFileViewer({
            attributes: {
              documentId: $this.attributes.conventionDocumentId,
            },
          });
        },
      }];
      if (this.attributes.letterOfMissionDocumentId) {
        documents.push({
          title: 'Lettre de mission',
          onClick() {
            analytics.track(OPENED_LETTER_OF_MISSION);
            $this.openFileViewer({
              attributes: {
                documentId: $this.attributes.letterOfMissionDocumentId,
              },
            });
          },
        });
      }
      return documents;
    },
  },
  methods: {
    ...mapActions(['openFileViewer']),
  },
};
</script>
